module.exports = __webpack_public_path__ + "static/media/card-design-thank-you.aa6bb06a.png";